import { mapGetters } from 'vuex';

const FRANCO = {
  ALLEMAGNE: 100,
  AUTRICHE: 125,
  BELGIQUE: 80,
  ESPAGNE: 95,
  FRANCE: 70,
  ITALIE: 95,
  LUXEMBOURG: 80,
  'PAYS-BAS': 80,
  PORTUGAL: 95,
  POLOGNE: 100,
};

const MONDIAL_RELAY_PRICE = {
  ALLEMAGNE: 9,
  AUTRICHE: 11.5,
  BELGIQUE: 7,
  ESPAGNE: 8.5,
  FRANCE: 5.5,
  ITALIE: 8.5,
  LUXEMBOURG: 7,
  'PAYS-BAS': 7,
  PORTUGAL: 8.5,
  POLOGNE: 9,
};

export default {
  data() {
    return {
      deliveryMethod: '',
      defaultDeliveryPostalPrice: 7.5,
    };
  },

  watch: {
    order: {
      immediate: true,
      nested: true,
      handler: (value, oldValue) => {
        if (value && value.address.address && oldValue && value.address.address.country !== oldValue.address.address.country) {
          this.deliveryMethod = '';
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      cart: 'shop/cart',
      coupon: 'app/coupon',
    }),

    country() {
      return this.order?.address.address.country?.toUpperCase();
    },

    franco() {
      if (this.country) {
        return FRANCO[this.country];
      }

      return null;
    },

    defaultDeliveryMondialRelayPrice() {
      if (this.country) {
        return MONDIAL_RELAY_PRICE[this.country];
      }

      return null;
    },

    totalProducts() {
      let total = 0;

      Object.keys(this.cart).forEach(key => {
        total += this.cart[key].price * this.cart[key].quantity;

        if (this.cart[key].options !== undefined) {
          if (this.cart[key].options.length > 0) {
            this.cart[key].options.forEach(option => {
              total +=
                this.cart[key].quantity * (option.price * (option.quantity || 1));
            });
          }
        }
      });

      return total;
    },

    hiddenType() {
      // Get all hidden types
      const hiddenType = this.cart.map(a => a.hiddenType);

      // Set new array with unique hidden type
      return [...new Set(hiddenType)];
    },

    deliveryPostalPrice() {
      if (
        this.coupon.type &&
        (this.coupon.type === 'delivery' ||
          this.coupon.type === 'percent-delivery')
      ) {
        return 0;
      }

      return this.defaultDeliveryPostalPrice;
    },

    deliveryMondialRelayPrice() {
      if (
        this.coupon.type &&
        (this.coupon.type === 'delivery' ||
          this.coupon.type === 'percent-delivery')
      ) {
        return 0;
      }

      if (
        this.totalProducts + ((this.coupon && this.coupon.amount) || 0) >=
        this.franco
      ) {
        return 0;
      }

      return this.defaultDeliveryMondialRelayPrice;
    },

    deliveryPrice() {
      let price =
        this.deliveryMethod === 'mondial-relay'
          ? this.deliveryMondialRelayPrice
          : this.deliveryPostalPrice;

      // if only gift hidden type is set
      if (this.hiddenType.length <= 1 && this.hiddenType[0] === 'gift') {
        price = 0;
      }

      if (
        this.coupon.type &&
        (this.coupon.type === 'delivery' ||
          this.coupon.type === 'percent-delivery')
      ) {
        price = 0;
      }

      if (
        this.totalProducts + ((this.coupon && this.coupon.amount) || 0) >=
        this.franco &&
        this.deliveryMethod === 'mondial-relay'
      ) {
        price = 0;
      }

      return price;
    },
  },
};
